// extracted by mini-css-extract-plugin
export default {"badge":"ViewQrTagBatch_badge__Zbuxa","assigned":"ViewQrTagBatch_assigned__nNSUD","unassigned":"ViewQrTagBatch_unassigned__Ch+WW","code":"ViewQrTagBatch_code__Cgr7a"};